import { type Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser'

// ── Replace these with your actual Azure Entra ID values ─────────────────────
// Set VITE_ENTRA_CLIENT_ID and VITE_ENTRA_TENANT_ID in your .env.local file.
const CLIENT_ID   = import.meta.env.VITE_ENTRA_CLIENT_ID   ?? 'YOUR_CLIENT_ID'
const TENANT_ID   = import.meta.env.VITE_ENTRA_TENANT_ID   ?? 'YOUR_TENANT_ID'
const REDIRECT_URI = import.meta.env.VITE_ENTRA_REDIRECT_URI ?? window.location.origin

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: REDIRECT_URI,
    postLogoutRedirectUri: REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        if (level === LogLevel.Error) console.error('[MSAL]', message)
        else if (level === LogLevel.Warning) console.warn('[MSAL]', message)
      },
      logLevel: import.meta.env.DEV ? LogLevel.Warning : LogLevel.Error,
    },
  },
}

/** Login scopes — `openid profile email` are the minimum for ID token claims. */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
}

export const msalInstance = new PublicClientApplication(msalConfig)
